import React from 'react';
import { CloudRain } from 'lucide-react';

const Inp = ({ label, value, onChange, placeholder, type = 'text' }) => (
  <div>
    <label className="text-[10px] font-sans font-semibold text-stone-500 uppercase tracking-wide mb-0.5 block">{label}</label>
    <input type={type} value={value || ''} onChange={e => onChange(e.target.value)} placeholder={placeholder}
      className="w-full text-xs font-sans px-2.5 py-1.5 border border-stone-200 rounded-lg bg-white focus:border-primary focus:outline-none" />
  </div>
);

export const PlanBSection = ({ planB, onChange }) => {
  const update = (field, value) => onChange({ ...planB, [field]: value });

  return (
    <div data-testid="plan-b-section" className="space-y-4">
      <div>
        <h3 className="font-sans font-semibold text-stone-800 text-sm">Plan B / Weather</h3>
        <p className="text-xs font-sans text-stone-500 mt-0.5">Plan for bad weather</p>
      </div>

      <div className="bg-amber-50/50 rounded-2xl border border-amber-200/30 p-4 flex items-start gap-3">
        <CloudRain className="w-5 h-5 text-amber-600 mt-0.5 flex-shrink-0" />
        <p className="text-xs font-sans text-amber-700 leading-relaxed">
          Siden the wedding er utendors, anbefaler vi a ha en solid Plan B klar. Sett en dato for nar dere skal ta beslutningen.
        </p>
      </div>

      <div className="bg-white rounded-2xl border border-stone-100 p-4 space-y-3">
        <Inp label="Alternative indoor venue" value={planB.alternativeVenue} onChange={v => update('alternativeVenue', v)} placeholder="Navn og adresse" />

        <div>
          <label className="text-xs font-sans font-medium text-stone-600 mb-2 block">Telt-oppsjon?</label>
          <div className="flex gap-2">
            {['Ja', 'Nei', 'Kanskje'].map(opt => (
              <button key={opt} type="button" onClick={() => update('tentOption', opt)}
                className={`text-xs font-sans px-3 py-2 rounded-xl border transition-all ${
                  planB.tentOption === opt ? 'bg-primary/10 border-primary text-primary' : 'bg-white border-stone-200 text-stone-600 hover:border-stone-400'
                }`}>{opt}</button>
            ))}
          </div>
        </div>

        {planB.tentOption === 'Ja' && (
          <div className="grid grid-cols-3 gap-2">
            <Inp label="Telt-type" value={planB.tentType} onChange={v => update('tentType', v)} placeholder="e.g. stretch-telt" />
            <Inp label="Size" value={planB.tentSize} onChange={v => update('tentSize', v)} placeholder="e.g. 10x15m" />
            <Inp label="Vendor" value={planB.tentVendor} onChange={v => update('tentVendor', v)} placeholder="Firma" />
          </div>
        )}

        <div className="flex flex-wrap gap-3">
          {[
            { id: 'umbrellas', label: 'Paraplyer til guests' },
            { id: 'heaters', label: 'Varmeovner' },
            { id: 'fans', label: 'Vifter' },
          ].map(item => (
            <label key={item.id} className="flex items-center gap-2 cursor-pointer">
              <input type="checkbox" checked={planB[item.id] || false} onChange={e => update(item.id, e.target.checked)}
                className="rounded border-stone-300 text-primary" />
              <span className="text-xs font-sans text-stone-600">{item.label}</span>
            </label>
          ))}
        </div>

        <Inp label="Alternativ seremoni-lokasjon" value={planB.alternativeCeremony} onChange={v => update('alternativeCeremony', v)} placeholder="Name/venue for indoor ceremony" />

        <div className="grid grid-cols-2 gap-2">
          <Inp label="Beslutningsdato for Plan B" value={planB.decisionDate} onChange={v => update('decisionDate', v)} type="date" />
          <Inp label="Time for beslutning" value={planB.decisionTime} onChange={v => update('decisionTime', v)} placeholder="e.g. kl. 08:00" />
        </div>

        <div className="grid grid-cols-2 gap-2">
          <Inp label="Contact person" value={planB.contactPerson} onChange={v => update('contactPerson', v)} placeholder="Navn" />
          <Inp label="Phone" value={planB.contactPhone} onChange={v => update('contactPhone', v)} placeholder="Phone" />
        </div>

        <Inp label="Notes" value={planB.notes} onChange={v => update('notes', v)} placeholder="Andre merknader om Plan B" />
      </div>
    </div>
  );
};
